<template>
  <div>
    <h1 class="page-title">{{ $t('Contract.title') }}</h1>

    <div class="contract-container">
      <pdf-viewer :src="contractPdf" />

      <div class="row mb-2" v-if="canSign">
        <div class="col">
          <div class="checkbox check-primary float-right">
            <input type="checkbox" id="apply-signature" @change="onSignatureChange">
            <label for="apply-signature">
              {{ $t('Contract.applySignature') }}
            </label>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <router-link class="btn" :to="cancelRoute">{{ $t('Contract.cancel') }}</router-link>
        </div>
        <div class="col">
          <button type="button" class="btn btn-primary pull-right" @click="create" v-bind:disabled="createLoading">
            <i class="fa fa-spinner fa-spin" v-if="createLoading"></i>
            {{ $t('Contract.validate') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import pdfViewer from './pdfViewer';
  import _ from 'lodash';

  export default {
    name: 'ContractPreview',
    props: ['offerIds'],
    components: { pdfViewer },
    data() {
      return {
        createLoading: false,
        applySignature: false,
        offerIdsAsArray: []
      };
    },
    computed: {
      ...mapGetters({
        contractPdf: 'contracts/contractPdf',
        authorizations: 'contracts/authorizations',
      }),
      offerId: function() {
        return parseInt(this.$route.params.id);
      },
      contractTemplateId: function() {
        return parseInt(this.$route.params.contract_id);
      },
      canSign: function() {
        return this.authorizations.can_sign;
      },
      cancelRoute: function() {
        return {
          name: 'OfferContract',
          params: {
            id: this.offerId,
            contract_id: this.contractTemplateId
          }
        };
      }
    },
    methods: {
      ...mapActions({
        getContractTemplate: 'contracts/getContractPdf',
        createContract: 'contracts/createContract',
        getAuthorizations: 'contracts/getAuthorizations'
      }),
      buildParams: function() {
        const params = {
          contract_template_id: this.contractTemplateId,
          offer_ids: this.offerIdsAsArray
        };
        return params;
      },
      pdfParams: function() {
        const params = this.buildParams();
        params.main_offer_id = this.offerId;

        return params;
      },
      createParams: function() {
        const params = this.pdfParams();
        params.apply_signature = this.applySignature;

        return params;
      },
      create: async function() {
        this.createLoading = true;
        try {
          let contract = await this.createContract(this.createParams());

          this.$router.push({
            name: 'Contract',
            params: { id: contract.id }
          });
        } catch(error) {}
        finally {
          this.createLoading = false;
        }

      },
      onSignatureChange: function(event) {
        this.applySignature = event.target.checked;
      },
      initOfferIdsAsArray: function() {
        this.offerIdsAsArray.push(this.offerId);

        if (!_.isEmpty(this.offerIds)) {
          const offerIds = _.isArray(this.offerIds) ? this.offerIds : new Array(this.offerIds);
          this.offerIdsAsArray = this.offerIdsAsArray.concat(offerIds);
        }
      }
    },
    mounted: function() {
      this.initOfferIdsAsArray();
      this.getAuthorizations(this.buildParams());
      this.getContractTemplate(this.pdfParams());
    }
  }
</script>

<style lang="scss" scoped>
.contract-container {
  max-width: 22cm;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/contracts/ContractPreview.vue